import React from 'react'

const ShiftManagement = () => {
  return (
    <div>ShiftManagement</div>
  )
}

export default ShiftManagement